import { SVGProps } from 'react';
const SvgFileText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='https://www.w3.org/2000/svg'
    width={24}
    height={24}
    fill='none'
    stroke='currentColor'
    strokeWidth={2}
    strokeLinecap='round'
    strokeLinejoin='round'
    className='file-text_svg__feather file-text_svg__feather-file-text'
    aria-labelledby='fileTextTitle'
    {...props}
  >
    <title id='fileTextTitle'>File Text</title>
    <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' />
    <path d='M14 2v6h6M16 13H8M16 17H8M10 9H8' />
  </svg>
);
export default SvgFileText;
